import CommonFooter from "./Components/CommonFooter";
import CommonHeader from "./Components/CommonHeader";
import CartProvider from "./Contexts/CartContext";
import { dashboardConfig } from "./Dashboards/Admin/constants";
import CategoriesPage from "./Pages/CategoriesPage";
import ContactUs from "./Pages/ContactUs";
import MainPage from "./Pages/MainPage";
import ProductDetailPage from "./Pages/ProductDetailPage";
import ProductsPage from "./Pages/ProductsPage";
import ProjectDetailPage from "./Pages/ProjectDetailPage";
import ProjectsPage from "./Pages/ProjectsPage";

const config = {
    application: {
        name: "Golan Timber Trade - גולן סחר עץ",
        logo: "/static/images/golan-timber-trade-logo.png",
        auth: {
            enableRegister: false,
        },
        commonConfig: {
            showOfflineDialog: false
        },
        theme: {
            mode: "light",
            primary: {
                main: "#2E673E",
            },
            secondary: {
                main: "#DF643B",
            }
        }
    },
    pagesCommons: {
        header: {
            type: "CompositeSections",
            sections: [
                {
                    type: "SimpleContent",
                    spec: {
                        object: <CommonHeader />
                    }
                },
            ]
        },
        footer: {
            type: "CompositeSections",
            sections: [
                {
                    type: "SimpleContent",
                    spec: {
                        object: <CommonFooter />
                    }
                }
            ]
        }
    },
    pages: [
        {
            path: '/',
            spec: {
                type: "Simple",
                object: <MainPage />
            }
        },
        {
            path: '/categories',
            spec: {
                type: "Simple",
                object: <CategoriesPage />
            }
        },
        {
            path: '/projects',
            spec: {
                type: "Simple",
                object: <ProjectsPage />
            }
        },
        {
            path: '/projects/:project_id',
            spec: {
                type: "Simple",
                object: <ProjectDetailPage />
            }
        },
        {
            path: '/contact',
            spec: {
                type: "Simple",
                object: <ContactUs />
            }
        },
        {
            path: '/category/:category_id/products',
            spec: {
                type: "Simple",
                object: <ProductsPage />
            }
        },
        {
            path: '/category/:category_id/products/:product_id',
            spec: {
                type: "Simple",
                object: <ProductDetailPage
                orderType="getQuote"
                whatsappNumber="972542421677"
                 />
            }
        },
        // {
        //     path: '/checkout',
        //     spec: {
        //         type: "Simple",
        //         object: <OrderConfirmationPage />
        //     }
        // }
    ],
    contextsProviders: [CartProvider],
    dashboards: [
        dashboardConfig
    ],
    languages: {
        default: 'he-IL',
        list: [
            { code: 'he-IL', name: 'עברית' },
        ]
    }
}

export default config;